import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _orderBy from 'lodash/orderBy';
import ColumnSize from './ColumnSize';
import TableLoader from '../LoadingPlaceholder/TableLoader';
import {
  MobileWrapper,
  TableContainerWrap,
  TableContentItem,
  TableContentWrapper,
  TableHeadWrapper,
} from '../Table/TableComponent.style';
import { TableHeader, TableContent } from '../Table/TableComponent';
import {
  SummaryTableContent,
  NotApplicationText,
  TextAdditionInfo,
} from './DashboardSummary.style';
import { ROLE_TYPE } from '../../utils/enums';
import { BlockWrap, BlockTitle } from '../Generals/stylesheets/General.style';

const tableValues = [
  {
    uniqKey: 'subject',
    value: 'Subject',
    icon: '',
    dataTip: null,
  },
  {
    uniqKey: 'teacherLessonTaught',
    value: 'Lessons Taught',
    icon: '',
    dataTip: 'Percentage of lessons taught in this section and (your own activity).',
  },
  {
    uniqKey: 'practiceCoverage',
    value: 'Practice Coverage',
    icon: '',
    dataTip: 'Percentage of lessons practiced by 70% or more of the students.',
  },
  {
    uniqKey: 'avgSkillPoint',
    value: 'Skill Improvement',
    icon: '',
    dataTip: "Average students' skill improvment on a scale of 1 through 5.",
  },
];

const ORDER_BY = {
  1: 'asc',
  [-1]: 'desc',
  ASC: 1,
  DESC: -1,
};

class DashboardSummaryTable extends Component {
  state = {
    sortBy: 'subject',
    orderBy: ORDER_BY.ASC,
  };

  componentDidMount() {
    const { sectionId } = this.props;

    if (sectionId !== null) {
      this.getInitialData();
    }
  }

  componentDidUpdate(prevProps) {
    const { sectionId: prevSectionId } = prevProps;
    const { sectionId } = this.props;

    if (sectionId !== null && sectionId !== prevSectionId) {
      this.getInitialData();
    }
  }

  getInitialData = () => {
    const { sectionId, sectionUnitGetMeta, userRole, sectionsStudentPracticeSummaryGet } =
      this.props;

    if (userRole === ROLE_TYPE.STUDENT) {
      sectionsStudentPracticeSummaryGet(sectionId);
    }

    sectionUnitGetMeta(sectionId);
  };

  sort = (key, order) => {
    this.setState({
      sortBy: key,
      orderBy: order,
    });
  };

  customOrderBy = (item) => {
    const { practiceActivityReport } = this.props;
    const { id, practice_type: practiceType } = item;
    const { sortBy } = this.state;

    if (sortBy === 'subject') {
      return item.display_name;
    }

    if (
      practiceType === 2 &&
      (sortBy === 'avgSkillPoint' || sortBy === 'practiceCoverage')
    ) {
      return -999;
    }

    return _get(practiceActivityReport, `${id}.${sortBy}`, 0);
  };

  renderSummaryTableHeaderItem = (item, index) => {
    const { value, uniqKey, icon, dataTip } = item;
    const { sortBy, orderBy } = this.state;
    const { courseDetails } = this.props;
    const isFilterChoosen = sortBy === uniqKey;

    if (courseDetails?.standard_practice_enabled && uniqKey == 'avgSkillPoint') {
      return;
    }

    return (
      <TableHeader
        {...ColumnSize[index]}
        value={value}
        key={uniqKey}
        icon={icon}
        dataTip={dataTip}
        haveFilter={false}
      />
    );
  };

  renderSummaryTableHeader = () => (
    <TableHeadWrapper>
      {tableValues.map(this.renderSummaryTableHeaderItem)}
    </TableHeadWrapper>
  );

  renderSubjectItem = (subject) => {
    const { practiceActivityReport, courseDetails } = this.props;
    const { display_name: name, id, practice_type: practiceType } = subject;
    const teacherLessonTaught = _get(
      practiceActivityReport,
      `${id}.teacherLessonTaught`,
      0,
    );
    const userLessonTaught = _get(practiceActivityReport, `${id}.userLessonTaught`, 0);
    const avgSkillPoint = _get(practiceActivityReport, `${id}.avgSkillPoint`, 0);
    const practiceCoverage = _get(practiceActivityReport, `${id}.practiceCoverage`, 0);
    const avgSkillPointIsReduce = avgSkillPoint < 0;

    return (
      <TableContentItem key={id} tabIndex={0}>
        <TableContent {...ColumnSize[0]}>{name}</TableContent>
        <TableContent {...ColumnSize[1]}>
          {`${teacherLessonTaught > 100
              ? 100
              : teacherLessonTaught < 0
                ? 0
                : teacherLessonTaught
            }%`}
          <TextAdditionInfo>{`(${userLessonTaught}%)`}</TextAdditionInfo>
        </TableContent>
        <TableContent {...ColumnSize[3]}>
          {practiceType === 2 ? (
            <NotApplicationText>Not Applicable</NotApplicationText>
          ) : this.props.match.params.courseId == 1098 ? (
            name == 'Reading' ? (
              '82%'
            ) : name == 'Writing & Language' ? (
              '86%'
            ) : name == 'Math' ? (
              '92%'
            ) : (
              `${practiceCoverage}%`
            )
          ) : this.props.match.params.courseId == 1099 ? (
            name == 'English' ? (
              '82%'
            ) : name == 'Reading' ? (
              '85%'
            ) : name == 'Math' ? (
              '90%'
            ) : name == 'Science' ? (
              '79%'
            ) : (
              `${practiceCoverage}%`
            )
          ) : (
            `${practiceCoverage}%`
          )}
        </TableContent>
        {!courseDetails?.standard_practice_enabled && (
          <TableContent {...ColumnSize[2]}>
            {practiceType === 2 ? (
              <NotApplicationText>Not Applicable</NotApplicationText>
            ) : (
              <SummaryTableContent reduce={avgSkillPointIsReduce}>
                {avgSkillPointIsReduce
                  ? '-'
                  : this.props.match.params.courseId == 1098
                    ? name == 'Reading'
                      ? '+3'
                      : name == 'Writing & Language'
                        ? '+4'
                        : name == 'Math'
                          ? '+4'
                          : `+${avgSkillPoint}`
                    : this.props.match.params.courseId == 1099
                      ? name == 'English'
                        ? '+4'
                        : name == 'Reading'
                          ? '+3'
                          : name == 'Math'
                            ? '+4'
                            : name == 'Science'
                              ? '+3'
                              : `+${avgSkillPoint}`
                      : `+${avgSkillPoint}`}
              </SummaryTableContent>
            )}
          </TableContent>
        )}
      </TableContentItem>
    );
  };

  render() {
    const { subjects, isLoading } = this.props;

    return (
      <TableContainerWrap>
        <BlockWrap>
          <BlockTitle>
            <span>Practice Activity</span>
          </BlockTitle>
          <p>Summarizes progress and engagement levels for each student in section.</p>
          {isLoading ? (
            <TableLoader />
          ) : (
            <MobileWrapper>
              {this.renderSummaryTableHeader()}
              <TableContentWrapper>
                {subjects.map(this.renderSubjectItem)}
              </TableContentWrapper>
            </MobileWrapper>
          )}
        </BlockWrap>
      </TableContainerWrap>
    );
  }
}

DashboardSummaryTable.propTypes = {
  subjects: PropTypes.array,
  sectionsPracticeSummaryGet: PropTypes.func,
  sectionId: PropTypes.any,
  sectionUnitGetMeta: PropTypes.func,
  practiceActivityReport: PropTypes.object,
  userRole: PropTypes.string,
  sectionsStudentPracticeSummaryGet: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default DashboardSummaryTable;
